module.exports = __webpack_public_path__ + "static/media/unknown-deer.3bef3b92.jpg";